var VisitsPageRouteName;
(function (VisitsPageRouteName) {
    VisitsPageRouteName["CANCEL_VISIT"] = "Cancel";
    VisitsPageRouteName["DRAFT_WAYPOINT_DETAILS"] = "Visit";
    VisitsPageRouteName["OFFICE_PROCEDURE_DETAILS"] = "Office/Procedure";
    VisitsPageRouteName["RESCHEDULE_VISIT"] = "Reschedule";
    VisitsPageRouteName["VISITS_PAGE"] = "Visits";
})(VisitsPageRouteName || (VisitsPageRouteName = {}));

export { VisitsPageRouteName };
